import React from "react";
import { FaCamera } from "react-icons/fa";

import {
  DEFAULT_AVATAR,
  getFullName,
  getPhotoUrl,
} from "../utils/judokaProfileUtils";

function JudokaProfileHero({ judoka, onChangePhoto, t }) {
  const photo = getPhotoUrl(judoka);
  const fullName = getFullName(judoka);

  return (
    <div className="relative bg-slate-950 p-6 text-white">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(249,115,22,0.24),transparent_35%),radial-gradient(circle_at_bottom_right,rgba(37,99,235,0.28),transparent_32%)]" />

      <div className="relative flex flex-col items-center text-center">
        <div className="relative">
          <div className="absolute -inset-2 rounded-[2.2rem] bg-gradient-to-br from-blue-500 to-orange-400 opacity-80 blur-sm" />

          <img
            src={photo}
            alt="Avatar du judoka"
            className="relative h-40 w-40 rounded-[2rem] border-4 border-white bg-white object-cover shadow-2xl sm:h-48 sm:w-48"
            onError={(event) => {
              event.currentTarget.src = DEFAULT_AVATAR;
            }}
          />
        </div>

        <button
          type="button"
          onClick={onChangePhoto}
          className="mt-5 inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-white px-4 py-2 text-sm font-bold text-slate-950 shadow-lg transition hover:-translate-y-0.5 active:translate-y-0"
        >
          <FaCamera />
          {t("judokaProfile.changePhoto", {
            defaultValue: "Changer la photo",
          })}
        </button>

        <h2 className="mt-6 font-titre text-3xl font-bold leading-tight">
          {fullName}
        </h2>

        {judoka?.genre && (
          <p className="mt-2 text-sm font-semibold text-white/60">
            {judoka.genre}
          </p>
        )}
      </div>
    </div>
  );
}

export default JudokaProfileHero;